import React, { useMemo } from 'react';
import '@fortawesome/fontawesome-svg-core/styles.css';
import './App.css';
import Preloader from './components/Preloader';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeComponent from './components/HomeComponent';
import ProductDetailsSection from './components/ProductDetailsSection';
import FloatingSocialBar from './components/FloatingSocialBar';

function App() {
  // 🌟 نحمل فقط الصور الأساسية اللي بتظهر للزائر في أولي الثواني (Hero / Logo)
  const criticalImages = useMemo(() => [
    '/images/logo.webp',
    '/images/land-1.webp',
    '/images/land-2.webp',
    '/images/land-3.webp',

  ], []);

  return (
    <Preloader imageUrls={criticalImages}>
      <div className="App">
        <Router>
          <FloatingSocialBar />
          <Routes>
            <Route path="/" element={<HomeComponent/>}/>
            <Route path="/:title" element={<ProductDetailsSection/>} />
          </Routes>
        </Router>
      </div>
    </Preloader>
  );
}

export default App;